module.exports = __webpack_public_path__ + "img/norway-diabetes-mellitus-male.9f433258.png";